const o = {
  name: "KnowYourCustomerKyc",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2ZM9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7Z" fill="currentColor"/>
<path d="M7 16C5.34228 16 4 17.3423 4 19V22H2V19C2 16.2377 4.23772 14 7 14H13V16H7Z" fill="currentColor"/>
<path d="M22.4141 17L16.9999 22.4142L13.5857 19L14.9999 17.5858L16.9999 19.5858L20.9999 15.5858L22.4141 17Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as KnowYourCustomerKyc
};
